<template>

    <div class="ap-container">

        <div v-if="isNotGoogle" class="ap-bloc-container">

            <div class="lp-logo-container">

                <img :src="logoSrc" class="lp-logo">

            </div>

            <p class="screen-subtitle">{{ $t(`login_provider_tuto_web_title_${provider}`) }}</p>

            <div v-for="(item, index) in advices" class="grey-bloc-container">

                <div v-show="step >= item" class="ghost-bloc">

                    <div :class="{ 'anim-grey-bloc': item !== 1}" class="grey-bloc">

                        <div class="grey-bloc-left">

                            <div v-if="index + 1 === step" class="ap-circle ap-dark-circle">{{ item }}</div>

                            <div v-else class="ap-circle ap-green-circle">

                                <img class="ap-check" src="/img/icons/check-white.svg">

                            </div>


                        </div>

                        <div class="grey-bloc-right">

                            <markdown :blank="true" :text="convertProviderSubtitle(item)" class="grey-bloc-title"></markdown>

                            <markdown :blank="true" :text="convertProviderText(item)" v-show="convertProviderText(item)" class="grey-bloc-subtitle"></markdown>

                        </div>


                    </div>

                </div>

            </div>

            <mq-layout :mq="['sm', 'md']" class="fixed-container">

                <button v-if="lastItem" class="btn btn-big btn-green" @click="done">{{ $t('global_cta_done') }}</button>

                <button v-else class="btn btn-big btn-blue" @click="nextStep">{{ $t('global_cta_next') }}</button>

            </mq-layout>

            <mq-layout :class="{ 'fixed-container-end': tutoFinish }" class="fixed-container" mq="lg">

                <button :class="{ 'btn-green': tutoFinish }" class="btn btn-blue" @click="nextStep">{{ computedBtnNext }}</button>

                <div v-if="electedProvider" class="separator"></div>

                <button v-if="electedProvider" class="btn btn-grey btn-help" @click="needHelp">{{ computedBtnHelp }}</button>

            </mq-layout>

        </div>

        <div v-else class="bloc__container">

            <h1 class="bloc__title">{{ $t(`login_provider_tuto_web_V2_${provider}_title`) }}</h1>

            <div class="bloc__green__container">

                <img class="bloc__green__img" src="/img/icons/infos-green.svg">

                <markdown :blank="true" :text="$t(`login_provider_tuto_web_V2_${provider}_description`)" class="bloc__green__text"></markdown>

            </div>


            <div v-for="(item, index) in getProviderSteps" v-show="index <= indexV2" :class="{ 'bloc__item__container-done': index < indexV2}" class="bloc__item__container">

                <h2 class="bloc__item__title">{{ $t(item.title) }}</h2>

                <p v-show="index === indexV2" class="bloc__item__text">{{ $t(item.text) }}</p>

                <button v-show="index === indexV2" class="btn btn-blue bloc__item__btn" @click="clickProviderStepsBtn(index)">
                    <span>{{ $t(item.btn) }}</span>
                    <img class="bloc__item__icon" src="/img/icons/arrow-right-white.svg">
                </button>

                <img v-if="index < indexV2" class="bloc__item__check" src="/img/icons/check-green.svg">

            </div>

            <button :class="{'btn-disable': !showBigBtn}" class="btn btn-big btn-blue bloc__btn" @click="clickBigBtn">{{ getStepBtnText }}</button>


        </div>

    </div>

</template>

<script>

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import Markdown from '@/components/Markdown'

import SessionStorage from '@/helpers/sessionStorage'

export default {

    name: 'login-provider-tuto-web',

    components: {Markdown},

    props: {

        provider: {
            type: String,
            default: ''
        },

        logoSrc: {
            type: String,
            default: ''
        }

    },

    computed: {

        lastItem: function () {
            return this.step >= this.advices
        },

        tutoFinish: function () {
            return this.step > this.advices
        },

        computedBtnNext: function () {

            return this.tutoFinish ? this.$t('login_provider_tuto_web_everything_done') : this.$t('login_provider_tuto_web_it_is_done')

        },

        computedBtnHelp: function () {

            return this.tutoFinish ? this.$t('login_provider_tuto_web_lost_help') : this.$t('login_provider_tuto_web_need_help')

        },

        electedProvider: function () {

            return this.provider === 'google' || this.provider === 'outlook'

        },

        isNotGoogle: function () {
            return this.provider !== 'google'
        },

        getProviderSteps() {
            return this.providerSteps[this.provider]
        },

        getStepBtnText: function () {
            return this.indexV2 === this.getProviderSteps.length - 1 && this.showBigBtn
                ? this.$t('login_provider_tuto_web_V2_cta_all_done')
                : this.$t(`login_provider_tuto_web_V2_${this.provider}_cta_step_${this.indexV2 + 1}`)
        },

        isDesktop: function () {
            return this.$mq !== 'sm'
        }
    },

    data() {
        return {
            advices: 0,
            step: 1,
            providerSteps: {
                google: [
                    {
                        title: 'login_provider_tuto_web_V2_google_title_imap',
                        text: 'login_provider_tuto_web_V2_google_description_imap',
                        link: 'https://mail.google.com/mail/u/1/#settings/fwdandpop',
                        btn: 'login_provider_tuto_web_V2_google_cta_activate_imap',
                        eventLink: 'link_imap'
                    },
                    {
                        title: 'login_provider_tuto_web_V2_google_title_2FA',
                        text: 'login_provider_tuto_web_V2_google_description_2FA_google',
                        link: 'https://myaccount.google.com/u/1/signinoptions/two-step-verification?rapt=AEjHL4P60I06wZZeVdk62ynLMLTj0htLdZ_R9MYqKVc-B6SH5MwTepBxw2w1cq2XRh3yuH5F5GBUdtMINKcWk999CdCYQVpc-A',
                        btn: 'login_provider_tuto_web_V2_google_cta_activate_2FA',
                        eventLink: 'link_2FA'
                    },
                    {
                        title: 'login_provider_tuto_web_V2_google_title_app_password',
                        text: 'login_provider_tuto_web_V2_google_description_app_password',
                        link: 'https://myaccount.google.com/apppasswords?rapt=AEjHL4MyVrSrHEfjlximg9HCIeU4nPSc2Y2szCH30ezhUGvuLCuuXa6pySzlj4L3TZ-i5KtvUe6pEOd7wOz65Yv_w3T172lwgA',
                        btn: 'login_provider_tuto_web_V2_google_cta_app_password',
                        eventLink: 'link_app_password'
                    }
                ]
            },
            showBigBtn: false,
            indexV2: 0,
            email: ''
        }
    },

    mounted() {

        this.email = SessionStorage.getItem('email')

        let counter = 1
        let bool = true

        while (bool) {

            const languageKey = `login_provider_tuto_web_subtitle_${counter + 1}_${this.provider}${(this.provider === 'gmx' || this.provider === 'web') && this.isDesktop ? '_desktop' : ''}`
            if (this.$te(languageKey)) {
                counter++
            } else {
                bool = false
            }
        }

        this.advices = counter

        //new flow for google
        if (this.provider === 'google') {

            Tag.pageViewAll(this, 'login_provider_tuto_web_V2', this.provider)
        }
    },

    methods: {

        back() {

            this.$emit('back')

        },

        nextStep() {

            if (this.step <= this.advices) {

                this.step = this.step + 1

                setTimeout(function () {

                    try {

                        window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})

                    } catch (ignored) {
                        // do nothing
                    }

                }, 10)

            } else {

                this.next()

            }
        },

        needHelp() {

            if (this.provider === 'google') {

                Tag.clickAmplitude(this, 'help', 'google')

                switch (I18n.get(this)) {
                    case 'fr-FR':
                        window.open('https://cleanfox.io/blog/creer-une-adresse-mail-gmail/', '_blank', 'rel="noopener,noreferrer,nofollow"')
                        break
                    default:
                        window.open('https://cleanfox.io/en/fox/faq/#question-2-7', '_blank', 'rel="noopener,noreferrer,nofollow"')
                }

            } else if (this.provider === 'outlook') {

                Tag.clickAmplitude(this, 'help', 'outlook')

                I18n.is.french(this)
                    ? window.open('https://cleanfox.io/blog/astuces-hotmail-outlook/connexion_cleanfox-microsoft/', '_blank', 'rel="noopener,noreferrer,nofollow"')
                    : window.open('https://cleanfox.io/en/fox/faq/#question-2-8', '_blank', 'rel="noopener,noreferrer,nofollow"')
            }


        },

        done() {

            this.next()

        },

        convertProviderSubtitle(index) {
            const languageKey = `login_provider_tuto_web_subtitle_${index}_${this.provider}${(this.provider === 'gmx' || this.provider === 'web') && this.isDesktop ? '_desktop' : ''}`
            if (this.provider === 'gmx' || this.provider === 'web') {
                const url = `https://www.${this.email ? this.email.split('@')[1] : 'gmx.com'}/`
                return this.$tc(languageKey, 0, {url})
            }
            return this.$t(languageKey)
        },

        convertProviderText(index) {
            return this.$te(`login_provider_tuto_web_description_${index}_${this.provider}${(this.provider === 'gmx' || this.provider === 'web') && this.isDesktop ? '_desktop' : ''}`)
                ? this.$t(`login_provider_tuto_web_description_${index}_${this.provider}${(this.provider === 'gmx' || this.provider === 'web') && this.isDesktop ? '_desktop' : ''}`)
                : ''
        },

        next() {

            Tag.clickAmplitude(this, 'understood')

            this.$emit('next')

        },

        goAppPass() {

            this.$emit('goAppPass')

        },

        clickProviderStepsBtn(index) {

            this.showBigBtn = true

            window.open(this.getProviderSteps[index].link, '_blank', 'rel="noopener,noreferrer,nofollow"')

            Tag.clickAll(this, this.getProviderSteps[this.indexV2].eventLink)


        },

        clickBigBtn() {

            if (this.showBigBtn) {

                if (this.indexV2 < this.getProviderSteps.length - 1) {

                    this.showBigBtn = false
                    this.indexV2 = this.indexV2 + 1
                    Tag.clickAll(this, `step_${this.indexV2}`)
                } else {
                    Tag.clickAll(this, 'done')
                    this.$emit('next')
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.bloc {
    &__container {
        width: 100%;
        max-width: 480px;
        display: flex;
        flex-direction: column;
        padding: 32px 0;
        border-radius: 8px;
        background-color: $white;
    }

    &__title {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.15;
        color: $charcoal;
        text-align: center;
    }

    &__green {
        &__container {
            margin: 24px 0;
            padding: 16px 24px;
            background-color: $mint;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
        }

        &__img {
            width: 32px;
            object-fit: contain;
            margin-right: 16px;
        }

        &__text {
            font-size: 15px;
            font-weight: 500;
            line-height: 1.5;
            text-align: left;
            color: $rifle;
        }
    }

    &__item {

        &__container {
            margin: 8px 32px;
            padding: 16px;
            border-radius: 8px;
            background-color: $timberwolf;
        }

        &__container-done {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        &__title {
            font-size: 17px;
            font-weight: bold;
            line-height: 1.15;
            text-align: left;
            color: $charcoal;
            margin: 0;
        }

        &__text {
            font-size: 15px;
            font-weight: 500;
            line-height: 1.5;
            text-align: left;
            color: $charcoal;
            margin-top: 4px;
        }

        &__btn {
            height: 48px;
            width: 100%;
            justify-content: space-between;
            padding: 24px;
            margin-top: 16px;
        }

        &__icon {
            width: 24px;
            object-fit: contain;
        }

        &__check {

        }
    }

    &__btn {
        margin: 24px 32px 0;
        width: auto;
    }
}

.ap-container {
    @media screen and (min-width: $above-tablet-length) {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-grow: 1;
        align-items: center;
        padding: 50px;
    }
}

.ap-bloc-container {
    padding: 26px 16px 32px;
    background-color: $white;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    color: $midnight;
    align-items: center;
    margin-bottom: 108px;
    @media screen and (min-width: $above-tablet-length) {
        padding: 40px;
        max-width: 480px;
        border-radius: 8px;
        box-shadow: 0 2px 10px 3px rgba(0, 0, 0, 0.15);
        height: fit-content;
    }
}

.lp-logo-container {
    @media screen and (min-width: $above-tablet-length) {
        width: 144px;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.lp-logo {
    max-width: 128px;
    max-height: 72px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {

    }
}

.screen-subtitle {
    font-size: 17px;
    line-height: 1.41;
    margin-top: 11px;
    text-align: left;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 24px;
    }
}

.grey-bloc-container {
    overflow: hidden;
    width: 100%;
}

.ghost-bloc {
    position: relative;
}

.grey-bloc {
    width: 100%;
    border-radius: 8px;
    background-color: #f1f1f1;
    padding: 16px;
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    position: relative;
    top: 0;
    left: 0;
}

.grey-bloc-left {
    width: 40px;
}

.ap-circle {
    width: 24px;
    height: 24px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.6;
    color: $white;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ap-dark-circle {
    background-color: $midnight;
}

.ap-green-circle {
    background-color: $green;
}

.ap-check {
    width: 15px;
    object-fit: contain;
}

.grey-bloc-right {
    width: 100%;
    text-align: left;
}

.grey-bloc-title {
    font-size: 17px;
    font-weight: bold;
    line-height: 1.41;
    letter-spacing: -0.2px;
}

.grey-bloc-subtitle {
    font-size: 17px;
    line-height: 1.41;
    margin-top: 8px;
    display: block;
}

.fixed-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px 16px 32px;
    background-color: $white;
    @media screen and (min-width: $above-tablet-length) {
        position: static;
        padding: 16px 0 0;
        display: flex;
        flex-direction: row;
    }
}

.fixed-container-end {
    @media screen and (min-width: $above-tablet-length) {
        flex-direction: column;
    }
}

.btn-help {
    color: $aquamarine;
}

.separator {
    width: 16px;
    height: 8px;
}

.anim-grey-bloc {
    animation: animap2show 500ms ease-in-out 50ms 1 normal forwards;
    opacity: 0;
}

@keyframes animap2show {

    0% {
        top: 200px;
        opacity: 0;
    }

    100% {
        opacity: 1;
        top: 0;
    }
}
</style>
